// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3_7-Y","colMin":"styles_colMin__1tYan","colCheckbox":"styles_colCheckbox__20Ncw"};